import { BRAND_LOGO_ROWS } from "@/assets/brand-logos";
import { cn } from "@/lib/utils";

export function LogoMarquee({
  className,
  fade = false,
}: {
  className?: string;
  fade?: boolean;
}) {
  return (
    <div className={cn("relative w-full overflow-hidden", className)}>
      {fade && (
        <div className="pointer-events-none absolute inset-0 z-10 bg-gradient-to-b from-transparent to-mf-neutral-50" />
      )}
      <div className={cn("flex w-full flex-col gap-3", fade && "-mt-9 gap-2")}>
        <LogoMarqueeRow logos={BRAND_LOGO_ROWS[0]} direction="right" />
        <LogoMarqueeRow logos={BRAND_LOGO_ROWS[1]} direction="left" />
        <LogoMarqueeRow logos={BRAND_LOGO_ROWS[2]} direction="right" />
      </div>
    </div>
  );
}

function LogoMarqueeRow({
  logos,
  direction,
}: {
  logos: readonly string[];
  direction: "left" | "right";
}) {
  const track = [...logos, ...logos];
  return (
    <div className="w-full overflow-hidden">
      <div
        className={
          direction === "right"
            ? "flex w-max animate-[onboarding-logo-marquee-right_40s_linear_infinite] gap-3"
            : "flex w-max animate-[onboarding-logo-marquee-left_40s_linear_infinite] gap-3"
        }
      >
        {track.map((src, index) => (
          <img
            key={`${src}-${index}`}
            src={src}
            alt=""
            className="size-[72px] shrink-0 overflow-hidden rounded-[24px] object-cover"
          />
        ))}
      </div>
    </div>
  );
}
